import InitialLoader from "components/InitilalLoader";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap";
import "../../Subscription/Subscription.scss";
import CommonSeriesInput from "./CommonSeriesInput";
import { randomKey } from "../../../utils/utils";
import { useMaterialOptions } from "./hooks/useMaterialOptions";
import { useAllSeries } from "./hooks/useAllSeries";
import { useAllUom } from "./hooks/useAllUom";
import { useAddUpdateSeries } from "./hooks/useAddUpdateSeries";
import { useDeleteMaterialSeries } from "./hooks/useDeleteMaterialSeries";
import { useAddManufactureOrSubType } from "./hooks/useAddManufactureOrSubType";
import DeleteConfirmModal from "components/common/DeleteConfirmModal";

function MaterialPricing() {
  const [selectCatagory, setSelectCatagory] = useState("");
  const [selectCatagoryType, setSelectCatagpoyType] = useState("");
  const [selectManufacture, setSelectManufacture] = useState("");
  const [selectSeriesType, setSelectSeriesType] = useState("");
  const [add, setAdd] = useState(false);
  const [addNewSeries, setAddNewSeries] = useState(false);
  const [allPrefered, setAllPrefered] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showAddNew, setShowAddNew] = useState(false);
  const [modal, setModal] = useState(null);

  const { data: pricing, isLoading } = useMaterialOptions();

  const catEntry = pricing.find((p) => p.category === selectCatagory);
  const typesList = catEntry ? catEntry.categoryType.map((t) => t.typeName) : [];
  const ctEntry = catEntry?.categoryType.find((t) => t.typeName === selectCatagoryType);
  const manufacturerList = ctEntry?.manufacturer || [];
  const subTypes = (selectManufacture
    ? ctEntry?.manufacturersWithSubType?.find((m) => m.manufacturer === selectManufacture)?.subType
    : null) ?? ctEntry?.subType ?? [];
  const subName = ctEntry?.subTypeName || "";

  const seriesParams = (() => {
    if (!selectCatagory || !selectCatagoryType) return null;
    if (manufacturerList.length > 0 && !selectManufacture) return null;
    if (subTypes.length > 0 && !selectSeriesType) return null;
    return {
      category: selectCatagory,
      categoryType: selectCatagoryType,
      ...(selectManufacture && { manufacturer: selectManufacture }),
      ...(selectSeriesType && { subType: selectSeriesType }),
    };
  })();

  const uomParams = selectCatagory && selectCatagoryType ? { category: selectCatagory, categoryType: selectCatagoryType } : null;
  const { data: materialSeriesData = [], isLoading: isLoadingSeries } = useAllSeries(seriesParams);
  const { data: uomList } = useAllUom(uomParams);
  const { mutate: saveOrUpdate } = useAddUpdateSeries();
  const { mutate: addManufacturerOrType } = useAddManufactureOrSubType();
  const { mutate: remove, isPending: isDeleting } = useDeleteMaterialSeries();

  const submitModal = () => {
    if (!modal?.value?.trim()) return;
    if (modal.type === "manufacturer") {
      setSelectManufacture(modal.value.trim());
      setModal(null);
    } else if (modal.type === "seriesType") {
      addManufacturerOrType(
        { category: selectCatagory, categoryType: selectCatagoryType, manufacturer: selectManufacture, subType: modal.value.trim() },
        { onSuccess: () => { setSelectSeriesType(modal.value.trim()); setModal(null); } }
      );
    }
  };

  const allSeriesUom = Array.isArray(uomList) ? uomList[0] : (uomList?.uom || "");
  const allUomType = materialSeriesData?.[0]?.uomType || "";

  useEffect(() => { setSelectCatagpoyType(""); setSelectManufacture(""); setSelectSeriesType(""); setAdd(false); }, [selectCatagory]);
  useEffect(() => { setSelectManufacture(""); setSelectSeriesType(""); }, [selectCatagoryType]);
  useEffect(() => { setSelectSeriesType(""); }, [selectManufacture]);

  useEffect(() => {
    if (!selectCatagory || !selectCatagoryType) { setShowAddNew(false); return; }
    if (manufacturerList.length > 0 && !selectManufacture) { setShowAddNew(false); return; }
    setShowAddNew(selectManufacture ? true : manufacturerList.length === 0);
  }, [selectCatagory, selectCatagoryType, selectManufacture, manufacturerList.length]);

  const showOptions = (list) => list.map((d) => <option key={d} value={d}>{d}</option>);
  const saveData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const editData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const deleteData = (id) => { setDeleteId(id); setIsDelete(true); };
  const confirmDelete = () => { remove(deleteId, { onSuccess: () => { setIsDelete(false); setDeleteId(null); }, onError: () => { setIsDelete(false); setDeleteId(null); } }); };

  if (isLoading) return <InitialLoader />;

  return (
    <>
      <Modal isOpen={!!modal} toggle={() => setModal(null)}>
        <ModalHeader toggle={() => setModal(null)}>
          Add {modal?.type === "manufacturer" ? "Manufacturer" : "Series Type"}
        </ModalHeader>
        <div style={{ padding: "1rem" }}>
          <Form.Control
            placeholder={modal?.type === "manufacturer" ? "Manufacturer name" : "Series type name"}
            value={modal?.value || ""}
            onChange={(e) => setModal((m) => ({ ...m, value: e.target.value }))}
          />
        </div>
        <ModalFooter>
          <Button color="primary" onClick={submitModal}>Save</Button>{" "}
          <Button color="secondary" onClick={() => setModal(null)}>Cancel</Button>
        </ModalFooter>
      </Modal>

      <DeleteConfirmModal
        isOpen={isDelete}
        toggle={() => !isDeleting && setIsDelete(false)}
        onConfirm={confirmDelete}
        isLoading={isDeleting}
      />

      <Row style={{ marginBottom: "2%" }}>
        <Col md="3">
          <Form.Group>
            <Form.Label>Category</Form.Label>
            <Form.Control as="select" onChange={(e) => setSelectCatagory(e.target.value)}>
              <option value="">Choose...</option>
              {showOptions(pricing.map((p) => p.category))}
            </Form.Control>
          </Form.Group>
        </Col>

        {selectCatagory && typesList.length > 0 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>{selectCatagory} Type</Form.Label>
              <Form.Control as="select" value={selectCatagoryType} onChange={(e) => setSelectCatagpoyType(e.target.value)}>
                <option value="">Choose...</option>
                {showOptions(typesList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {selectCatagoryType && manufacturerList.length > 0 && (
          <Col md="3">
            <Form.Group>
              <Form.Label>
                Manufacturer{" "}
                <button className="btn btn-link btn-sm p-0" onClick={() => setModal({ type: "manufacturer", value: "" })}>+ Add New</button>
              </Form.Label>
              <Form.Control as="select" value={selectManufacture} onChange={(e) => setSelectManufacture(e.target.value)}>
                <option value="">Choose...</option>
                {showOptions(manufacturerList)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}

        {(selectManufacture || (selectCatagoryType && !manufacturerList.length)) && subName && (
          <Col md="3">
            <Form.Group>
              <Form.Label>
                {subName === "subType" ? "Type" : subName}{" "}
                <button className="btn btn-link btn-sm p-0" onClick={() => setModal({ type: "seriesType", value: "" })}>+ Add New</button>
              </Form.Label>
              <Form.Control as="select" value={selectSeriesType} onChange={(e) => setSelectSeriesType(e.target.value)}>
                <option value="">Choose...</option>
                {showOptions(subTypes)}
              </Form.Control>
            </Form.Group>
          </Col>
        )}
      </Row>

      {isLoadingSeries ? <InitialLoader /> : (
        <>
          {showAddNew && !add && (
            <Row style={{ marginBottom: "4%", float: "right" }}>
              <Col md="12">
                <button className="btn btn-primary" onClick={() => { setAdd(true); setAddNewSeries(true); }}>Add New</button>
              </Col>
            </Row>
          )}

          {(materialSeriesData?.length > 0 || add) && (
            <Row style={{ marginTop: "10%" }}>
              <Col md="1"><Form.Group style={{ textAlign: "center" }}><Form.Label>Preferred</Form.Label></Form.Group></Col>
              <Col md="3"><Form.Group style={{ textAlign: "center" }}><Form.Label>Series</Form.Label></Form.Group></Col>
              <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>UOM</Form.Label></Form.Group></Col>
              {allUomType && allUomType !== "N/A" && <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>{allUomType}</Form.Label></Form.Group></Col>}
              <Col md="2"><Form.Group style={{ textAlign: "center" }}><Form.Label>Price Per UOM</Form.Label></Form.Group></Col>
            </Row>
          )}

          {add && (
            <CommonSeriesInput
              saveData={saveData} editData={true} UOM={allSeriesUom}
              setAddNewSeries={setAddNewSeries} addNewSeries={addNewSeries}
              category={selectCatagory} manufacturer={selectManufacture}
              categoryType={selectCatagoryType} subType={selectSeriesType}
              deleteData={deleteData} allPrefered={allPrefered}
              setAllPrefered={setAllPrefered} setAdd={setAdd} add={add}
            />
          )}

          {materialSeriesData?.length > 0
            ? materialSeriesData.map((data) => (
              <CommonSeriesInput
                key={data._id || randomKey}
                setAddNewSeries={setAddNewSeries} saveData={editData} deleteData={deleteData}
                Preferred={data?.isPreferred} Series={data?.series} UOM={allSeriesUom}
                categoryUomType={data.uomType} BDLPerSq={data?.uomValue} PricePerUom={data?.uomPrice}
                _id={data._id} addNewSeries={addNewSeries} category={selectCatagory}
                manufacturer={selectManufacture} categoryType={selectCatagoryType}
                subType={selectSeriesType} allPrefered={allPrefered} setAllPrefered={setAllPrefered}
                priceData={data} materialSeriesData={materialSeriesData}
                setAllSeriesData={() => {}} setAdd={setAdd} add={add}
              />
            ))
            : showAddNew && <h6 style={{ textAlign: "center", marginTop: "10%" }}>No Data Found</h6>}
        </>
      )}
    </>
  );
}

export default MaterialPricing;
